const _ = x => x

export default _


